import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function UnsavedChangesDialog({
  open,
  onCancel,
  onConfirm,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent className="p-8 flex flex-col gap-6">
        <DialogHeader>
          <DialogTitle>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesTitle')}
          </DialogTitle>
          <DialogDescription className="text-neutrals-900 pt-4 pb-8">
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onConfirm} variant={'outline'}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesAbort')}
          </Button>
          <Button onClick={onCancel}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesContinue')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
